import React, {Component} from 'react'
import StatTable from "../../components/StatTable/StatTable";
import axios from "axios";

class StatTableContainer extends Component {

  state = {
    originalStats: [],
    currentStats: [],
    error: false
  };

  componentDidMount = () => {
    axios.get('https://corona.lmao.ninja/v2/countries?sort=cases')
      .then(response => {
        this.setState({originalStats: response.data});
        this.getYesterdayStats();
        this.setState({currentStats: [...this.state.originalStats]})
      })
      .catch(error => {
        this.setState({error: true});
        throw new Error('Network connectivity issue, please try again shortly')
      })
  };

  getYesterdayStats = () => {
    axios.get('https://corona.lmao.ninja/v2/countries?yesterday=true&sort=cases')
      .then(response => {

        let originalStats = [...this.state.originalStats];

        this.state.originalStats = this.state.originalStats.map((stats, index) => {

          response.data.map(yesterdayStats => {

            if (yesterdayStats.countryInfo._id === stats.countryInfo._id) {
              originalStats[index] = {
                ...stats,
                yesterdayCases: yesterdayStats.todayCases,
                yesterdayDeaths: yesterdayStats.todayDeaths};
            }
          });
        });

        this.setState({originalStats: originalStats});
        this.setState({currentStats: originalStats});
      })
      .catch(error => {
        this.setState({error: true});
        throw new Error('Network connectivity issue, please try again shortly')
      })
  };

  handleSearch = (event) => {
    const keyword = event.target.value;
    let searchStats = [...this.state.originalStats];

    const currentStats = searchStats.filter(stats => {
      return !stats.country.search(new RegExp(keyword, 'i'));
    });

    this.setState({currentStats: currentStats})
  };

  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <StatTable currentStats={this.state.currentStats} onSearch={this.handleSearch}/>
        </div>
      </div>
    )
  }
}

export default StatTableContainer
